<template>
  <div>
    <v-expansion-panels accordion class="mt-2">
      <v-expansion-panel v-for="(item, itemIdx) in items" :key="itemIdx" :readonly="!item.content">
        <v-expansion-panel-header
          class="pa-3"
          :hide-actions="!item.content"
          :style="{ cursor: item.content ? 'pointer' : 'unset' }"
        >
          <slot name="header" v-bind="item">
            <div class="outside-icon" v-if="item.appendOuterIcon">
              <img width="20px" height="20px" :src="item.appendOuterIcon" />
            </div>
            <v-col cols="auto" class="pa-0 ma-0">
              <v-row no-gutters align="center">
                <v-col cols="auto" class="text-body-2 pr-2">
                  {{ item.title }}
                </v-col>
                <v-col cols="auto" v-if="item.icons && item.icons.length > 0">
                  <v-icon
                    v-for="(icon, iconIdx) of item.icons"
                    :key="iconIdx"
                    v-bind="icon"
                    @click.stop="$emit(icon.name, { item, idx: itemIdx })"
                  >
                    mdi-magnify
                  </v-icon>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="item.subtitle">
                <v-col cols="auto">
                  <italic-subheader :straightText="item.subtitle" />
                </v-col>
              </v-row>
            </v-col>
          </slot>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0">
          <slot name="content" v-bind="item">
            <v-col cols="auto" class="pa-0 ma-0">
              <v-row no-gutters align="center" class="text-body-2 text-left">
                {{ item.content }}
              </v-row>
            </v-col>
          </slot>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import ItalicSubheader from '@/components/ItalicSubheader';
export default {
  name: 'ExpandableList',
  components: { ItalicSubheader },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-expansion-panel-content__wrap {
    padding: 0 12px 16px;
  }
}
.outside-icon {
  position: absolute;
  left: -25px;
}
</style>
